const ModulTipi = {
    1: "SGK",
    2: "Ebasvuru",
    3: "IEP",
}

export default ModulTipi;
